module.exports = __webpack_public_path__ + "static/media/hair (27).1b559dfe.jpg";